module.exports = __webpack_public_path__ + "web/img/tab-bg.8dce7019.png";